import { useSelector } from 'react-redux';
import { canUse } from '../redux/subscriptionSlice';

// THE DOCTOR-PLAN QUESTION FOR A BUTTON (owner, 1 Oct 2026: every plan
// feature is now really refused by the server — 403 PLAN_FEATURE_MISSING).
//
// A plan control belongs to a DOCTOR. Only the signed-in doctor's own entry
// points are hidden here; the admin, staff and patients always get `true`
// (an admin acting on a doctor's resource is refused by the server, and the
// screen shows that reason instead — see utils/planRefusal.js).
//
// For a doctor, canUse() stays the one reader of the plan's controls, asked
// only once the resolved access says the plan rule governs them
// (`planApplies === true`):
//   · planApplies false — a tenant without the `subscriptions` feature; the
//     server grants every control there, so nothing is hidden;
//   · not answered yet (the access request is in flight, or failed) — the
//     entry point stays, like the server's own gate, which FAILS OPEN; the
//     server is the control, this is the courtesy, and a doctor whose access
//     request failed should not lose half the app over it.
export const planAllows = (state, controlId, role) => {
    if (String(role || '').toLowerCase() !== 'doctor') return true;
    if (state.subscription?.doctorAccess?.planApplies !== true) return true;
    return canUse(state, controlId);
};

const currentRole = () =>
    (typeof localStorage !== 'undefined' && localStorage.getItem('Role')) || '';

export default function usePlanControl(controlId) {
    const role = currentRole();
    return useSelector((state) => planAllows(state, controlId, role));
}
